import axios from 'axios';
import { message } from 'antd';

const updateClaimPercentByAccidentResponse = (initialValues, lossId, claimDataSource) => {
    const { ownCarLoss = {} } = initialValues;
    const accidentResponse = ownCarLoss.accidentResponse;
    // 待定或为空
    if (!accidentResponse || ['6', '04'].includes(accidentResponse)) {
        message.error(`请选择正确的事故责任!`);
        return;
    }
    let percent = 0;
    switch(accidentResponse) {
        // 全责
        case '01':
        case '1': percent = 100; break;
        // 主责
        case '02':
        case '2': percent = 70; break;
        // 次责
        case '03': 
        case '3': percent = 30; break;
        // 无责
        case '06': percent = 0; break;
        case '4': percent = 0; break;
        // 同责
        case '05':
        case '5': percent = 50; break;
        default: break;
    }
    return claimDataSource.map(item => {
        item.claimPercent = percent;
        item.claimAmount
        return item;
    });
}

// 根据
const computeClaimAmount = (tenantCode, dataSource = []) => {
    dataSource.forEach((item) => {
        if (![undefined, null].includes(item.claimPercent)) {
            let value,
                _claimPercent = [undefined, null].includes(
                    item.claimPercent
                )
                    ? 100
                    : item.claimPercent;
            if (tenantCode && tenantCode === 15) {
                value = (item.lossAmount * _claimPercent) / 100;
            } else {
                value =
                    ((item.lossAmount -
                        (item.trafficInsuranceAmount || 0)) *
                        _claimPercent) /
                    100;
            }
            item.claimAmount = value && +value.toFixed(2);
        }
    });
    return dataSource;
}

const getClaimInfoLossByLossId = (initialValues = {}, lossId = '') => {
    const { claimInfoList = [] } = initialValues || {};
    for (const claimInfo of claimInfoList || []) {
        const lossList = claimInfo && claimInfo.lossList ? claimInfo.lossList : [];
        for (const loss of lossList || []) {
            if (loss && loss.lossId && loss.lossId.toString() === lossId.toString()) {
                return loss || null;
            }
        }
    }
    return null;
}

const getLossTypeByLossId = (initialValues = {}, lossId = '', fallbackLossType = '') => {
    if (fallbackLossType) {
        return fallbackLossType;
    }
    const matchedLoss = getClaimInfoLossByLossId(initialValues, lossId);
    if (matchedLoss) {
        return matchedLoss.lossType || '';
    }
    const { ownCarLoss = {}, otherCarLoss = [] } = initialValues || {};
    if (ownCarLoss && ownCarLoss._id && ownCarLoss._id.toString() === lossId.toString()) {
        return ownCarLoss.lossType || '';
    }
    for (const loss of otherCarLoss || []) {
        if (loss && loss._id && loss._id.toString() === lossId.toString()) {
            return loss.lossType || '';
        }
    }
    return '';
}

const getClaimAmounts = (flowId, agentId, lossId, lossType = '') => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: `/api/lossAss/report/claimResp/claimAmounts`,
            params: {
                agentId,
                lossId,
                lossType,
                flowId
            }
        })
        .then((res) => {
            if (res.data.errCode === 0) {
                return resolve(res.data.result || []);
            } else {
                message.error(res.data.errInfo);
                return resolve([])
            }
        })
        .catch((err) => {
            message.error(err.message);
            return reject(err);
        });
    })
}

const handleSaveTableData = async (flowId, agentId, lossId, lossType, dataSource,) => {
    const url = `/api/lossAss/report/claimResp/claimAmounts`;
    return await axios({
        method: 'post',
        url,
        data: {
            agentId,
            lossId,
            lossType,
            flowId,
            claimLossAmounts: dataSource
        }
    });
};

async function autoCalculateClaimAmount (initialValues, currentAgent, source, lossId, lossType = '') {
    //  1. 保存工单详情
    const runAutoCalculate = async () => {
        try {
            const { flowId = '' } = initialValues;
            const { _id: agentId, tenant = {} } = currentAgent;
            const resolvedLossType = getLossTypeByLossId(initialValues, lossId, lossType);
            if (!resolvedLossType) {
                message.error('未获取到损失类型，请先选择损失类型');
                return;
            }
            // 查询理赔数据
            let data = await getClaimAmounts(flowId, agentId, lossId, resolvedLossType)
            // 计算赔付比例，更新理赔数据的赔付比例
            data = updateClaimPercentByAccidentResponse(initialValues, lossId, data);
            // 计算赔付金额
            data = computeClaimAmount(tenant.code, data);
            // 保存自动计算结果
            const res = await handleSaveTableData(flowId, agentId, lossId, resolvedLossType, data);
            if (res.data.errCode === 0) {
                // 保存成功，拉取最新数据
                if (this && this.props && this.props.actions && typeof this.props.actions.getCurrentReport === 'function') {
                    await this.props.actions.getCurrentReport(flowId, agentId);
                }
                if (this && typeof this.loadData === 'function') {
                    await this.loadData();
                }
                message.success('操作成功');
           } else {
                message.error(res.data.errInfo);
           }
        } catch (err) {

            message.error('操作失败，请稍后再试');
        }
   };

    if (this && this.props && typeof this.props.handleSubmit === 'function') {
        this.props.handleSubmit(runAutoCalculate);
        return;
    }

    await runAutoCalculate();
}

export {
    autoCalculateClaimAmount,
    updateClaimPercentByAccidentResponse,
    computeClaimAmount,
    getClaimAmounts,
    handleSaveTableData
}
